/**
 * @packageDocumentation
 * @module api.functional.event_logs.event_types
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { CompanyScopeQuery } from "../../../structures/CompanyScopeQuery";

/**
 * @controller EventLogController.eventTypes
 * @path GET /event-logs/event-types
 * @accessor api.functional.event_logs.event_types.eventTypes
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function eventTypes(
  connection: IConnection,
  query: eventTypes.Query,
): Promise<eventTypes.Output> {
  return PlainFetcher.fetch(connection, {
    ...eventTypes.METADATA,
    template: eventTypes.METADATA.path,
    path: eventTypes.path(query),
  });
}
export namespace eventTypes {
  export type Query = CompanyScopeQuery;
  export type Output = {
    eventTypes: string[];
    targetTypes: string[];
  };

  export const METADATA = {
    method: "GET",
    path: "/event-logs/event-types",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (query: Query) => {
    const variables: URLSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query as any))
      if (undefined === value) continue;
      else if (Array.isArray(value))
        value.forEach((elem: any) => variables.append(key, String(elem)));
      else variables.set(key, String(value));
    const location: string = "/event-logs/event-types";
    return 0 === variables.size
      ? location
      : `${location}?${variables.toString()}`;
  };
}
